<template>
  <span>
    <el-dialog
    title="删除"
    :visible.sync="analysisDetailFlag"
    append-to-body
    width="30%">
        <div>删除详情</div>
    </el-dialog>
    <el-button icon=""
            style="padding:0 .1rem" size="small" type="text" @click="deleteAction">删除</el-button>
  </span>
</template>

<script>
import { remove } from '@/api/v4ward/assess/task/assesstask';

export default {

  props: {
    query: {
      default: ()=>{}, //项目id
    },
    row: {
      default: ()=>{}, //项目id
    },
  },
    data(){
        return{
            
      analysisDetailFlag:false,
        }
    },
    methods:{
        deleteAction(){
            let row = this.row;
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
            this.$emit('refreshAction');
          this.$message.success('操作成功!');
        });
        }
    }
}
</script>

<style>

</style>